import { render, staticRenderFns } from "./ManterPerfisView.vue?vue&type=template&id=7bcb09e1"
import script from "./ManterPerfisView.vue?vue&type=script&lang=js"
export * from "./ManterPerfisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports